import * as React from 'react'
import { FC, useMemo } from 'react'
import { format } from 'date-fns'
import { useGetRejectedNote } from '../hooks/useGetRejectedNote'
import { getStyles } from './styling'
import { LightTooltip } from '@sales-center/components'
import { SoldServicesStatusTooltip } from '../SoldServicesStatusTooltip/SoldServicesStatusTooltip'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'
import { useTheme } from '@mui/material/styles'

interface Props {
  opportunityId: number
}

export const SoldServiceReviseNote: FC<Props> = (props) => {
  const { opportunityId } = props
  const [loading, note] = useGetRejectedNote(opportunityId)

  const { formatDate } = useLocalizationDateFormat()

  const formattedDate = useMemo(() => {
    if (note) {
      try {
        return (
          formatDate(note?.rejectedDate) +
          ' ' +
          format(new Date(note.rejectedDate), "'at' h:mm aa")
        )
      } catch {
        return null
      }
    } else {
      return null
    }
  }, [formatDate, note])
  const styles = getStyles(useTheme())
  return !loading && !!note ? (
    <Card raised variant="elevation" sx={styles.card}>
      <Box sx={styles.title}>{note.title}</Box>
      <Box>{note.detail}</Box>
      <Box sx={styles.footer}>
        Status{' '}
        <LightTooltip
          slotProps={{ tooltip: { sx: styles.tooltipPopup } }}
          sx={{
            ...styles.tooltipHotspot,
          }}
          title={<SoldServicesStatusTooltip />}
        >
          <InfoOutlined
            sx={styles.icon}
            data-test-id="soldServiceReviseNoteStatusInfoIcon"
          />
        </LightTooltip>
        <Box component="span" sx={styles.status}>
          Rejected
        </Box>
        {!!note && note.rejectedBy && formattedDate && (
          <>{` by ${note.rejectedBy} on ${formattedDate}`}</>
        )}
      </Box>
    </Card>
  ) : null
}
